export const ArrowUpIcon = ({ color = 'currentColor', width = 20, height = 20 }: { color?: string; width?: number; height?: number }) => (
  <svg width={width} height={height} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M10 15V5M10 5L5 10M10 5L15 10'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
